<div class="modal-header">
    <h4 class="modal-title drop-modal-title" id="modal-basic-title">{{pdfName}}</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal(false)"></button>
</div>
<div class="modal-body">
    <iframe [src]="pdfUrl | safeUrl" width="100%" height="100%"></iframe>
</div>
<div class="modal-footer">
    <div class="row">
        <div class="col-lg-12">
            <button type="button" class="btn btn-primary checkout-button" (click)="downloadPDF()">
                <span>Download PDF</span>
            </button>
        </div>
    </div>
</div>
  